import { useEffect, useState } from 'react'
import { getPrefillDataForDocUpload } from '../services/Api'
import RoundyModal from './RoundyModal/RoundyModal'

const TokenParser = ({ setUser, setIsPrefilled, fields }) => {
  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    GetPolicyDataFromToken(fields)
  }, [])

  const GetPolicyDataFromToken = async fields => {
    const searchParams = new URLSearchParams(window.location.search)
    const token = searchParams.get('tkn')
    searchParams.delete('tkn')
    if (!token) return

    try {
      const response = await getPrefillDataForDocUpload(token)
      if (response.data.Result == 'Fail') {
        setOpenModal(true)
        throw Error('Token expired or invalid')
      }

      let data = response.data;
      // Filter the response to return only specified fields
      if (fields && Array.isArray(fields)) {
        data = fields.reduce((acc, field) => {
          if (data[field] !== undefined) {
            acc[field] = data[field];
          }
          return acc;
        }, {});
      }

      setUser((prevData) => { return {...prevData, ...data}});
      setIsPrefilled(true);
      setIsPrefilled(true)
    } catch (err) {
      console.log(err)
      return null
    }
  }

  const handleOk = () => {
    window.location = '/my-account'
  }

  return (
    <>
      <RoundyModal
        isModalOpen={openModal}
        handleOk={handleOk}
        handleCancel={() => setOpenModal(false)}
        title="Session Expired"
        content="Your session has expired. Please login again."
        okText="LOG IN"
      />
    </>
  )
}

export default TokenParser
